import React, { useCallback } from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';
import hasReactChildren from 'utils/react/hasReactChildren.util';

import CN from './KnobInput.module.scss';

const KnobInput = ({
  tag,
  name: nameFromProps,
  value,
  emoji,
  selected,
  disabled,
  variant,
  onClick,
  children,
  ...extra
}) => {
  const name = fromAnyToTrimmed(nameFromProps);

  const { isDarkMode } = useTheme();

  const handleClick = useCallback(
    (ev) => {
      if (disabled) return;
      call('Knob.onClick', onClick, { name, raw: value, ev, event: ev });
    },
    [disabled, name, onClick, value],
  );

  return (
    <div
      {...extra}
      data-bem="KnobInput"
      data-tag={fromAnyToTrimmed(tag)}
      data-selected={fromAnyToBool(selected)}
      data-name={name}
      role="button"
      onClick={handleClick}
      tabIndex={0}
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN.active]: selected,
        [CN.inactive]: !selected,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <span className={CN.icon} />
      <div className={CN.name}>{hasReactChildren(children) ? children : name}</div>
      <div className={CN.emoji}>{emoji}</div>
    </div>
  );
};

export default KnobInput;
